// Demo seed data (non-module). Stored on window for use by demo-mode + config.js demo client.
// Everything is localStorage-only.
(function () {
  const now = new Date();
  const iso = (d) => new Date(d).toISOString();

  const demoUserId = 'demo_user';
  const demoAccountId = 'DEMO_ACC_1';

  const seed = {
    version: 1,
    users: [
      {
        id: demoUserId,
        email: 'demo@tripulacionfx.com',
        username: 'DEMO',
        user_type: 'user',
        user_plan: 'unlimited',
        expires_at: null,
        created_at: iso(now),
        last_login: iso(now)
      }
    ],
    accounts: [
      {
        id: demoAccountId,
        user_id: demoUserId,
        name: 'Cuenta Demo',
        type: 'challenge_f1',
        balance: 112.0,
        initial_balance: 100.0,
        status: 'active',
        priority: 'medium',
        is_primary: 1,
        is_archived: 0,
        archived_at: null,
        created_at: iso(now)
      }
    ],
    trades: [
      {
        id: 'DEMO_TRADE_1',
        account_id: demoAccountId,
        date: '2026-01-15',
        pair: 'GBPUSD',
        direction: 'LONG',
        risk: 1,
        result: 12,
        comment: 'Setup perfecto en H1, respetó soporte clave.',
        entry_time: '10:20',
        exit_time: '10:40',
        tradingview_url: '',
        timestamp: iso(new Date('2026-01-15T10:40:00Z')),
        ticket: 'DEMO-1',
        lot_size: 0.01,
        entry_price: 1.2701,
        exit_price: 1.2713,
        commission: 0,
        swap: 0,
        profit_usd: 12,
        import_source: 'demo'
      },
      {
        id: 'DEMO_TRADE_2',
        account_id: demoAccountId,
        date: '2026-01-16',
        pair: 'EURUSD',
        direction: 'SHORT',
        risk: 1,
        result: -6,
        comment: 'Entrada tardía; no respeté el plan.',
        entry_time: '14:05',
        exit_time: '14:18',
        tradingview_url: '',
        timestamp: iso(new Date('2026-01-16T14:18:00Z')),
        ticket: 'DEMO-2',
        lot_size: 0.01,
        entry_price: 1.0884,
        exit_price: 1.0890,
        commission: 0,
        swap: 0,
        profit_usd: -6,
        import_source: 'demo'
      }
    ],
    daily_notes: [
      {
        id: 'DEMO_NOTE_1',
        user_id: demoUserId,
        account_id: demoAccountId,
        date: '2026-01-15',
        sentiment: 'Calmado',
        note: 'Buen día. Seguí el plan y esperé confirmación.',
        day_outcome: 'win',
        created_at: iso(now),
        updated_at: iso(now)
      }
    ],
    payouts: [],
    installations: [],
    cashflows: []
  };

  try {
    window.DEMO_DB_SEED = seed;
  } catch (e) {
    // ignore
  }
})();
